import * as React from "react";
import {
  TextInput,
  SelectInput,
  ArrayInput,
  SimpleFormIterator,
  useRecordContext,
  required,
} from "react-admin";
import Transformer from "../../../common/Transformer";
import { AttributeEditComponent } from "./";
import { AttributeTypeEnum, AttributeOptionType } from "../../../common/enum";
import { Edit, TabbedForm, FormTab } from "src/enterprise/ra-rbac";
import { Grid } from "@mui/material";

export const AttributeEdit = (props) => {
  const transform = (data) => {
    Transformer(data, {
      remove: ["id", "type", "createdAt", "updatedAt"],
      update: {
        attributeSets: data.attribute_sets?.map(
          (op) => (op.id),
          data
        ),
        options: data.options?.map(
          (op) => ({ attribute: data.id, id: op.id, value: op.value }),
          data
        ),
      },
    });

    return data;
  };

  return (
    <Edit
      component={AttributeEditComponent}
      mutationMode="pessimistic"
      transform={transform}
    >
      <EditForm {...props} />
    </Edit>
  );
};

const EditForm = (props) => {
  const record = useRecordContext(props);

  const isOptionType = AttributeOptionType.includes(record.type);

  return (
    <TabbedForm>
      <FormTab label="General" name="general">
        <Grid container rowSpacing={1} columnSpacing={2}>
          <Grid item sm={12} lg={8}>
            <TextInput disabled source="id" />
          </Grid>
          <Grid item sm={12} lg={8}>
            <TextInput source="code" validate={required()} />
          </Grid>
          <Grid item sm={12} lg={8}>
            <TextInput source="name" validate={required()} />
          </Grid>
          <Grid item sm={12} lg={8}>
            <SelectInput
              source="type"
              choices={AttributeTypeEnum}
              validate={required()}
              disabled
            />
          </Grid>
        </Grid>
      </FormTab>
      {isOptionType && (
        <FormTab label="Options" name="options">
          <Grid container rowSpacing={1} columnSpacing={2}>
            <Grid item sm={12} lg={6}>
              <ArrayInput source="options">
                <SimpleFormIterator disableReordering inline>
                  <TextInput source="value" sx={{ minWidth: "35vw" }} />
                </SimpleFormIterator>
              </ArrayInput>
            </Grid>
          </Grid>
        </FormTab>
      )}
    </TabbedForm>
  );
};
